"use strict";

exports.__esModule = true;
exports.maximo = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MaximoToolbar = (0, _styledComponents["default"])(_core.Tooltip).withConfig({
  displayName: "maximo__MaximoToolbar",
  componentId: "sc-1k9pihu-0"
})(["margin:auto;"]);
var MaximoButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "maximo__MaximoButton",
  componentId: "sc-1k9pihu-1"
})(["margin:", ";"], function (p) {
  return p.disabled ? "0px 24px 0 0" : "-2px 24px 0 0";
});
var CriteriaList = _styledComponents["default"].ul.withConfig({
  displayName: "maximo__CriteriaList",
  componentId: "sc-1k9pihu-2"
})(["list-style:none;padding:0;"]);
var allowedTypes = ["Maximo-EM", "Maximo-CM", "Maximo-SA"];
function enableMaximoForTicket(ticket) {
  if (!ticket || !ticket.devices || !ticket.status || !ticket.type) {
    return false;
  }
  // Rule: Only applies to 1 device
  if (ticket.devices.length !== 1) {
    return false;
  }
  // Rule: Ticket status must be TICKET_STATUS_OPEN
  if (ticket.status !== _constants.TICKET_STATUS_OPEN) {
    return false;
  }
  // Rule: Should only have a single ticket type
  if (ticket.type.length !== 1) {
    return false;
  }
  // Rule: Ticket type must be one of those in allowedTypes
  if (!allowedTypes.includes(ticket.type[0].value)) {
    return false;
  }
  return true;
}
function getLinkStatus(ticket) {
  if (!ticket || !ticket.devices || !ticket.status || !ticket.type) {
    return _constants.LINK_STATUS_LINK;
  }
  var maximoLink = ticket.links.filter(function (link) {
    return link.type === _constants.LINK_TYPE_MAXIMO;
  })[0];
  if (!maximoLink) {
    return _constants.LINK_STATUS_LINK;
  }
  return maximoLink.status;
}
function renderMaximoButton(isEnabled, linkStatus, config, clickCallback) {
  if (linkStatus === _constants.LINK_STATUS_LINKING || linkStatus === _constants.LINK_STATUS_LINKED) {
    return /*#__PURE__*/_react["default"].createElement(MaximoButton, {
      "data-testid": "MaximoButton-Disabled",
      disabled: true,
      onClick: clickCallback
    }, config.text[linkStatus]);
  }
  if (isEnabled) {
    return /*#__PURE__*/_react["default"].createElement(MaximoButton, {
      "data-testid": "MaximoButton-Enabled",
      onClick: clickCallback
    }, config.text[linkStatus]);
  }
  return /*#__PURE__*/_react["default"].createElement(MaximoToolbar, {
    position: _core.Position.BOTTOM,
    content: /*#__PURE__*/_react["default"].createElement(CriteriaList, null, /*#__PURE__*/_react["default"].createElement("li", null, "Criteria:"), /*#__PURE__*/_react["default"].createElement("li", null, "1) Only ONE device is selected"), /*#__PURE__*/_react["default"].createElement("li", null, "2) Only ONE of these types: ", allowedTypes.join(", ")), /*#__PURE__*/_react["default"].createElement("li", null, "3) Ticket status is Open"))
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(MaximoButton, {
    disabled: true,
    onClick: clickCallback
  }, config.text[linkStatus])));
}
var maximo = exports.maximo = {
  getLinkStatus: getLinkStatus,
  isEnabled: enableMaximoForTicket,
  render: renderMaximoButton
};